/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Match_Type_ContainsInputs */



/**
* | output |
* | --- |
* | "Contains" |
*
* @param {Compliance_Match_Type_ContainsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_match_type_contains = /** @type {((inputs?: Compliance_Match_Type_ContainsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Match_Type_ContainsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Enthält")
	return /** @type {LocalizedString} */ ("Contains")
});